import { gql } from "@apollo/client";

export const GetOrganizationService = gql`
  query GetOrganizationService($id: String!) {
    organizationServiceOne(id: $id) {
      description
      duration
      isIndivdual
      isSelfEnroll
      isWaitlistEnabled
      name
      waitlistMax
      imgUrl
      serviceType {
        id
        name
      }
      policies {
        id
        name
      }
      revenueCategory {
        id
        name
      }
      locationServices {
        id
        cost
        isPrepay
        isActive
        description
        imgUrl
        location {
          id
          name
        }
        rooms {
          id
          name
        }
      }
    }
  }
`;

export const GetOrganizationServices = gql`
  query GetOrganizationServices($orgId: String!) {
    organizationServiceMany(orgId: $orgId) {
      id
      name
    }
  }
`;

export const OrganizationServicePage = gql`
  query GetOrganizationServicePage($pagination: PaginationInput!) {
    organizationServicePage(pagination: $pagination) {
      items {
        id
        name
        createdDate
        duration
        imgUrl
        serviceType {
          name
        }
        revenueCategory {
          name
        }
        locationServices {
          id
          location {
            id
          }
        }
      }
      totalRows
    }
  }
`;

export const GetLocationServices = gql`
  query GetLocationServices($locationId: String!) {
    locationServiceMany(locationId: $locationId) {
      id
      rooms {
        id
        name
        totalCapacity
      }
      organizationService {
        imgUrl
        waitlistMax
        duration
        description
        name
        isWaitlistEnabled
        isSelfEnroll
      }
    }
  }
`;

export const GetLocationService = gql`
  query GetLocationService($id: String!) {
    locationServiceOne(id: $id) {
      id
      rooms {
        id
        name
        totalCapacity
      }
      location {
        id
        name
        employees {
          id
          user {
            firstName
            lastName
          }
        }
        meetings {
          id
          startAt
          endAt
          duration
          room {
            id
          }
          instructor {
            id
          }
          location {
            id
          }
        }
      }
      organizationService {
        imgUrl
        waitlistMax
        duration
        description
        name
        isWaitlistEnabled
        isSelfEnroll
      }
    }
  }
`;

export const GetLocationServicesName = gql`
  query GetLocationServicesName($locationId: String!) {
    locationServiceMany(locationId: $locationId) {
      id
      organizationService {
        name
      }
    }
  }
`;

export const GetLocationServicesNameGroup = gql`
  query GetLocationServicesNameGroup($locationId: String!) {
    locationServiceMany(locationId: $locationId) {
      id
      organizationService {
        name
        isIndivdual
      }
    }
  }
`;

export const GetLocationServiceDetail = gql`
  query GetLocationServiceDetail($id: String!) {
    locationServiceOne(id: $id) {
      id
      imgUrl
      description
      isPrepay
      isActive
      cost
      rooms {
        id
        name
      }
      organizationService {
        id
        duration
        name
        isSelfEnroll
        waitlistMax
        revenueCategory {
          id
          name
        }
        serviceType {
          id
          name
        }
        policies {
          id
          name
        }
      }
    }
  }
`;
